<template>
	<div class="detail-wrap">
		<Loading v-if="!loading"/>
		<div class="base-info">
			<h3>{{scriptDetailInfo&&scriptDetailInfo.title}}</h3>
			<p class="author">{{scriptDetailInfo&&scriptDetailInfo.writer_type==1?'编剧':'策划'}}：{{scriptDetailInfo&&scriptDetailInfo.writer_name}}</p>
			<p class="gray-font">剧本类型：{{scriptDetailInfo&&scriptDetailInfo.one_cateid_name}}</p>
			<p class="gray-font">剧本分类：{{scriptDetailInfo&&scriptDetailInfo.two_cateid_name.join('、')}}</p>
			<p class="gray-font">完结状态：{{scriptDetailInfo&&scriptDetailInfo.over.name}}</p>
			<p class="end-logo" v-if="scriptDetailInfo&&scriptDetailInfo.over.value==1">{{scriptDetailInfo&&scriptDetailInfo.over.name}}</p>
			<p class="continue-logo" v-if="scriptDetailInfo&&scriptDetailInfo.over.value==0">{{scriptDetailInfo&&scriptDetailInfo.over.name}}</p>
		</div>
		<div class="score-box">
			<TvScore :detail="true"/>
		</div>
		<div class="assess-item-box">
			<h4>评定简述</h4>
			<div class="assess-item">
				<p class="item-title">
					<span class="black-title">题材创意、故事性</span>
					<span class="score">{{scoreNumItem&&scoreNumItem.idea_score}}分</span>
				</p>
				<pre class="item-cont">{{scoreDetail&&scoreDetail.idea}}</pre>
			</div>
			<div class="assess-item">
				<p class="item-title">
					<span class="black-title">情节推动、逻辑性</span>
					<span class="score">{{scoreNumItem&&scoreNumItem.plot_score}}分</span>
				</p>
				<pre class="item-cont">{{scoreDetail&&scoreDetail.plot}}</pre>
			</div>
			<div class="assess-item">
				<p class="item-title">
					<span class="black-title">影视作品转化效果</span>
					<span class="score">{{scoreNumItem&&scoreNumItem.transform_score}}分</span>
				</p>
				<pre class="item-cont">{{scoreDetail&&scoreDetail.transform}}</pre>
			</div>
			<div class="assess-item">
				<p class="item-title">
					<span class="black-title">人物设定、塑造</span>
					<span class="score">{{scoreNumItem&&scoreNumItem.character_score}}分</span>
				</p>
				<pre class="item-cont">{{scoreDetail&&scoreDetail.character}}</pre>
			</div>
			<div class="assess-item">
				<p class="item-title">
					<span class="black-title">七三三规律完成度</span>
					<span class="score">{{scoreNumItem&&scoreNumItem.rule_score}}分</span>
				</p>
				<pre class="item-cont">{{scoreDetail&&scoreDetail.rule}}</pre>
			</div>
			<div class="assess-item">
				<p class="item-title">
					<span class="black-title">世界观价值观</span>
					<span class="score">{{scoreNumItem&&scoreNumItem.view_score}}分</span>
				</p>
				<pre class="item-cont">{{scoreDetail&&scoreDetail.view}}</pre>
			</div>
			<div class="assess-item">
				<p class="item-title">
					<span class="red-title">修改建议</span>
				</p>
				<pre class="item-cont">{{scoreDetail&&scoreDetail.advise}}</pre>
			</div>
		</div>
	</div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import TvScore from '@/components/TvScore.vue'
import Loading from '@/components/Loading.vue'
export default {
	name:'TvScoreDetail',
	data(){
		return{
			scriptDetailInfo:'',          //剧本详情数据
			scriptType:'',                //当前剧本类型  1是电影  2是电视剧
			loading:false,                //控制加载画面显示隐藏
			scoreDetail:'',               //剧本评估详情
			scoreNumItem:'',             //评分分数
		}
	},
	created(){
		//获取顶部剧本信息
		Axios.get('/article/detail/'+this.$route.query.id).then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.scriptDetailInfo=response.data.data
					this.scriptType=response.data.data.type.value
                }
            }
		)
		
		//获取评估详情数据
		Axios.get('article/assess',{params:{type:Number(this.$route.query.type),id:Number(this.$route.query.id)}}).then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					this.scoreDetail=response.data.data
					this.scoreNumItem=JSON.parse(response.data.data.item)
					this.loading=true
				}
			},
			error=>{
				console.log(error)
			}
		)
	},
	components:{
		TvScore,
		Loading
	}
}
</script>

<style lang="scss" scoped>
	.detail-wrap{
		width:664px;
        margin:0 auto;
		padding:88px 0;
		position:relative;
		.base-info{
			padding:50px 0;
			h3{
				font-size:34px;
                color:#222;
                height:32px;
                margin-bottom:20px;
                font-weight:bold;
			}
			.author{
                color:#535353;
                font-size:24px;
                font-weight:500;
                margin-bottom:40px;
            }
			.gray-font{
				font-size:20px;
				color:#999;
				margin-bottom:20px;
			}
			.end-logo{
                position:absolute;
                top:148px;
                right:0px;
                width:80px;
                height:70px;
                background:url('../assets/img/statuslogr.png') no-repeat;
                background-size:cover;
                text-align:center;
                color:#fff;
                font-size:18px;
                line-height:50px;
                font-weight:bold;
            }
            .continue-logo{
                position:absolute;
                top:148px;
                right:0px;
                width:80px;
                height:70px;
                background:url('../assets/img/statuslogb.png') no-repeat;
                background-size:cover;
                text-align:center;
                color:#fff;
                font-size:18px;
                line-height:50px;
                font-weight:bold;
            }
		}
		.assess-item-box{
			.assess-item{
				margin-bottom:50px;
			}
			.black-title{
				float:left;
				display:inline-block;
				background:#535353;
				color:#fff;
				font-size:22px;
				width:200px;
				text-align:center;
				padding:10px 24px;
			}
			.red-title{
				float:left;
				display:inline-block;
				background:#C24B4F;
				color:#fff;
				font-size:22px;
				width:146px;
				text-align:center;
				padding:10px 24px;
			}
			.score{
				float:right;
				font-size:26px;
				color:#bf0000;
				font-weight:bold;
			}
			h4{
				font-size:28px;
				font-weight:bold;
				color:#222;
				padding:45px 0;
			}
			.item-title{
				margin-bottom:30px;
				overflow:hidden;
			}
			.item-cont{
				font-size:22px;
				color:#666;
				line-height:42px;
				white-space:pre-wrap;
			}
		}
	}
</style>